import { useGetBooksCategoryQuery } from "Services/CategoryApiSlice";
import { useGetAuthorsByCategoryQuery } from "Services/Admin/ActiveAuthorApiSlice";
import { useGetAllActiveAcademicsQuery } from "Services/Admin/ActiveAcademicApiSlice";
import { useGetAllActiveLanguagesQuery } from "Services/Admin/ActiveLanguageApiSlice";
import { useGetAllActiveMerchandisesQuery } from "Services/Admin/ActiveMerchandiseApiSlice";
import { Category } from "Types/Navbar";

export const useNavbarData = (hoveredCategoryName?: string | null) => {
  const { data: categoriesData, isLoading, error } = useGetBooksCategoryQuery();
  const { data: languagesData } = useGetAllActiveLanguagesQuery();
  const { data: academicsData } = useGetAllActiveAcademicsQuery();
  const { data: merchandisesData } = useGetAllActiveMerchandisesQuery();
  const languages = languagesData?.map((lang) => lang.language) || [];
  const academics = academicsData?.map((aca) => aca.academic) || [];
  const merchandises =
    merchandisesData?.map((merch) => merch.merchandise) || [];

  // console.log("Categories Data from API:", categoriesData);

  const mappedCategories: Category[] = (
    categoriesData?.map((cat) => {
      const actualSubs =
        cat.subClasses
          ?.filter((sub) => sub.subClassName && sub.subClassName.trim() !== "")
          ?.map((sub) => ({
            name: sub.subClassName as string,
            code: sub.subClassId,
          }))
          ?.filter((sub, index, self) => index === self.findIndex((s) => s.code === sub.code)) || [];

      const subs = [{ name: "None", code: "None" }, ...actualSubs];

      return {
        name: cat.categoryName,
        code: cat.categoryId,
        subs,
        image: "",
        isActive: "1",
      };
    }) || []
  ).filter((cat, index, self) => index === self.findIndex((c) => c.code === cat.code));

  const hoveredCategoryCode =
    hoveredCategoryName
      ? mappedCategories.find((c) => c.name === hoveredCategoryName)?.code ?? null
      : null;

  const { data: authorsByCategory, isLoading: isAuthorsLoading } =
    useGetAuthorsByCategoryQuery(hoveredCategoryCode!, {
      skip: !hoveredCategoryCode,
    });

  const authors = authorsByCategory ?? [];

  // console.log("Mapped Categories:", mappedCategories);

  return {
    mappedCategories,
    authors,
    isAuthorsLoading,
    languages,
    academics,
    merchandises,
    isLoading,
    error,
  };
};
